import { render } from "./TheTruDenChieuSang.vue?vue&type=template&id=759e5b5a"
import script from "./TheTruDenChieuSang.vue?vue&type=script&lang=js"
export * from "./TheTruDenChieuSang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__